import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Api from "Api/Api";
import Utils from "Utils";
import { custom } from "devextreme/ui/dialog";
import MailForm from "components/AdminComponents/MailForm";
import Paginator from "components/common/Paginator";
import { useLocation } from "@reach/router";
import { useUrlFilter } from "../../Hooks/utils";
import { investorType } from "formFields";
import { Checkbox } from "@mantine/core";
import { Select, Input } from "antd";
import { CSVLink } from "react-csv";
import { AntTable } from "components/AntComponents";

function Match(props) {
  const { selectedInvestor, dispatch, formFields } = props;

  const location = useLocation();
  const [filters, setFilters] = useUrlFilter();

  const [count, setCount] = useState(0);
  const [startupId, setStartupId] = useState(null);
  const [matchedInvestors, setMatchedInvestors] = useState(null);
  const [investorIds, setInvestorIds] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [businessDescription, setBusinessDescription] = useState("");
  const [processing, setProcessing] = useState(false);
  const [startupName, setStartupName] = useState(null);

  useEffect(() => {
    const investorIds = selectedInvestor.map(
      (selected) => selected.investor_id
    );
    setInvestorIds(investorIds);
  }, [selectedInvestor]);

  useEffect(() => {
    if (!formFields.length) {
      Utils.getFormFields()
    }
  }, [formFields])

  useEffect(() => {
    var startupId = location.pathname.split("/").splice(-1)[0];
    dispatch({ type: "toggleLoad" });
    Api.getStartupDetail(startupId).then((response) => {
      dispatch({ type: "toggleLoad" });
      if (response.status === 200) {
        setStartupId(startupId);
        setBusinessDescription(response.data.business_description);
        setStartupName(response.data.name);
        dispatch({
          type: "SectionSelected",
          payload: `Send To Investor (${response.data.name})`,
        });
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (filters) {
      getMatchedInvestors(
        filters?.page,
        filters?.search,
        filters?.sort,
        filters?.type,
        filters?.relationship_manager,
        filters?.tags,
        filters?.sector,
      );
    }
  }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

  const assignStartup = () => {
    Api.assignStartup(investorIds, startupId).then((response) => {
      if (response.status === 200) {
        Utils.notify("Record saved!", "success");
        dispatch({
          type: "clearSelectedInvestor",
        });
      }
    });
  };

  const sortingParams = [
    {
      name: "Name in ascending order",
      value: "name|asc",
    },
    {
      name: "Name in descending order",
      value: "name|desc",
    },
    {
      name: "Fund name in ascending order",
      value: "fund_name|asc",
    },
    {
      name: "Fund name in descending order",
      value: "fund_name|desc",
    },
    {
      name: "Match percentage in ascending order",
      value: "percentage|asc",
    },
    {
      name: "Match percentage in descending order",
      value: "percentage|desc",
    },
    {
      name: "Priority in ascending order",
      value: "priority|asc",
    },
    {
      name: "Priority in descending order",
      value: "priority|desc",
    },
    {
      name: "Min ticket size in ascending order",
      value: "min_ticket_size|asc",
    },
    {
      name: "Min ticket size in descending order",
      value: "min_ticket_size|desc",
    },
    {
      name: "Max ticket size in ascending order",
      value: "max_ticket_size|asc",
    },
    {
      name: "Max ticket size in descending order",
      value: "max_ticket_size|desc",
    },
  ];

  const addInvestor = () => {
    let myDialog = custom({
      title: "Send email notification",
      messageHtml: "<i>Do you want to send them email?</i>",
      buttons: [
        {
          text: "Send",
          onClick: (e) => {
            return true;
          },
        },
        {
          text: "Record",
          onClick: (e) => {
            return false;
          },
        },
      ],
    });
    myDialog.show().then((dialogResult) => {
      if (dialogResult) {
        setShowPopup(true);
      } else {
        assignStartup();
      }
    });
  };
  const getMatchedInvestors = (page = 1, search = "", sort = "", type = "", relationship_manager = "", tags = "", sector = "") => {
    setMatchedInvestors(null);
    let startupId = location.pathname.split("/").splice(-1)[0];
    dispatch({ type: "toggleLoad" });
    Api.getMatches(startupId, page, search, sort, type, relationship_manager, tags, sector).then((response) => {
      if (response.status === 200) {
        dispatch({ type: "toggleLoad" });
        if (response.data === "Processing") {
          setProcessing(true);
        } else {
          setMatchedInvestors(response.data.results);
          setCount(response.data.count);
          setProcessing(false);
        }
      }
    });
  };
  const rowSelected = (investor, selected) => {
    if (selected) {
      dispatch({
        type: "addSelectedInvestor",
        payload: investor,
      });
    } else {
      dispatch({
        type: "removeSelectedInvestor",
        payload: investor.investor_id,
      });
    }
  };
  const changeInvestor = async (investors_list) => {
    if (investors_list.length) {
      const response = await Api.getInvestorIdsFromEmail(investors_list);
      if (response.status === 200) {
        if (
          JSON.stringify(response.data) !== JSON.stringify(selectedInvestor)
        ) {
          dispatch({
            type: "replaceSelectedInvestor",
            payload: response.data.map((ids) => `${ids}`),
          });
        }
      }
    }
  };

  const removeSelectedUser = (investorId) => {
    dispatch({
      type: "removeSelectedInvestor",
      payload: investorId,
    });
  };

  const csvHeaders = [
    {
      label: 'Name',
      key: 'name'
    },
    {
      label: 'Fund name',
      key: 'fund_name'
    },
    {
      label: 'Stages',
      key: 'preferred_stages'
    },
    {
      label: 'Minimum ticket size',
      key: 'min_ticket_size'
    },
    {
      label: 'Maximum ticket size',
      key: 'max_ticket_size'
    },
    {
      label: 'Sectors',
      key: 'sectors'
    },
    {
      label: 'Segments',
      key: 'client_segments'
    },
    {
      label: 'Invested in countries',
      key: 'invest_in_countries'
    },
    {
      label: 'Investor type',
      key: 'investor_type'
    },
    {
      label: 'Priority',
      key: 'priority'
    },
    {
      label: 'Comment',
      key: 'comment_box'
    },
    {
      label: 'Match Percentage',
      key: 'match_percentage'
    },
  ]

  const headers = [
    {
      title: "",
      dataIndex: "id",
      render: (_, data) => {
        return (
          <Checkbox
            className="pointer"
            onChange={(event) =>
              rowSelected(data, event.currentTarget.checked)
            }
            checked={investorIds.includes(data.investor_id)}
          />
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Fund name",
      dataIndex: "fund_name",
    },
    {
      title: "Stages",
      dataIndex: "preferred_stages",
    },
    {
      title: "Minimum ticket size",
      dataIndex: "min_ticket_size",
    },
    {
      title: "Maximum ticket size",
      dataIndex: "max_ticket_size",
    },
    {
      title: "Sectors",
      dataIndex: "sectors",
      width: "10%",
      ellipsis: true,
    },
    {
      title: "Segments",
      dataIndex: "client_segments",
    },
    {
      title: "Invested in countries",
      dataIndex: "invest_in_countries",
    },
    {
      title: "Investor type",
      dataIndex: "investor_type",
    },
    {
      title: "Priority",
      dataIndex: "priority",
    },
    {
      title: "Comment",
      dataIndex: "comment_box",
      width: "10%",
      ellipsis: true,
    },
    {
      title: "Match Percentage",
      dataIndex: "match_percentage",
      render: (data) => {
        return (
          <div className="badge badge-pill badge-primary">
            {data} %
          </div>
        );
      },
    },
  ]

  return (
    <div className="card">
      <div className="card-body">
        <button
          className="btn btn-info mb-3"
          onClick={() => window.history.back()}
        >
          Back
        </button>
        <div>
          {matchedInvestors === "" ? (
            "Loading..."
          ) : (
            <>
              {processing ? (
                <div className="flex flex-column">
                  <h3>Please wait! Script is running in the background!</h3>
                  <h5>
                    Please refresh the page in sometime!{" "}
                    <button
                      className="btn btn-primary"
                      onClick={() => window.location.reload()}
                    >
                      Refresh
                    </button>
                  </h5>
                </div>
              ) : (
                <>
                  <div className="mb-3 flex">
                    <Input
                      mode="search"
                      className="mr-3"
                      placeholder="Search"
                      style={{ width: "15%" }}
                      allowClear
                      onPressEnter={(e) => {
                        setFilters({
                          page: 1,
                          search: e.target.value,
                        });
                      }}
                      onChange={(e) => {
                        if (e.target.value === "") {
                          setFilters({
                            page: 1,
                            search: ""
                          });
                        }
                      }}
                    />
                    <Select
                      style={{ width: "12%" }}
                      className="mr-3"
                      placeholder="Sort"
                      options={Utils.convertToAntSelectDatasource(
                        sortingParams,
                        {
                          displayExpr: "name",
                          valueExpr: "value"
                        }
                      )}
                      allowClear
                      defaultValue={filters?.sort}
                      onChange={(value) => setFilters({ sort: value })}
                    />
                    <Select
                      style={{ width: "12%" }}
                      className="mr-3"
                      allowClear
                      placeholder="Investor type"
                      options={Utils.convertToAntSelectDatasource(investorType)}
                      defaultValue={filters?.type}
                      onChange={(value) => setFilters({ type: value })}
                    />
                    <Select
                      style={{ width: "12%" }}
                      className="mr-3"
                      allowClear
                      placeholder="Relationship Manager"
                      options={Utils.convertToAntSelectDatasource(formFields.relationship_managers_choices || [])}
                      defaultValue={filters?.relationship_manager}
                      onChange={(value) => setFilters({ relationship_manager: value })}
                    />
                    <Select
                      style={{ width: "12%" }}
                      className="mr-3"
                      allowClear
                      placeholder="Sector"
                      options={Utils.convertToAntSelectDatasource(formFields.sector_choices || [])}
                      defaultValue={filters?.sector}
                      onChange={(value) => setFilters({ sector: value })}
                    />
                    <Select
                      className="mr-3"
                      style={{ width: "12%" }}
                      allowClear
                      placeholder="Tags"
                      options={Utils.convertToAntSelectDatasource(formFields.tag_choices || [])}
                      defaultValue={filters?.tags}
                      onChange={(value) => setFilters({ tags: value })}
                    />
                    <div>
                      {matchedInvestors && <CSVLink
                        data={matchedInvestors}
                        headers={csvHeaders}
                        filename={`${startupName}_match_records.csv`}
                      >
                        Export to CSV
                      </CSVLink>}
                    </div>
                  </div>
                  {!!selectedInvestor.length && (
                    <div className="mb-3 selectedInvestorsContainer">
                      <p>Selected Investors</p>
                      <div className="selectedInvestors flex">
                        {selectedInvestor.map((investor) => {
                          return (
                            <div className="investorTag">
                              <span>{investor.name}</span>
                              <i
                                className="material-icons pointer"
                                onClick={() => {
                                  removeSelectedUser(investor.investor_id);
                                }}
                              >
                                close
                              </i>
                            </div>
                          );
                        })}
                      </div>

                      <button
                        className={`btn btn-primary`}
                        onClick={addInvestor}
                      >
                        Add
                      </button>
                    </div>
                  )}
                  <AntTable
                    data={matchedInvestors}
                    headers={headers}
                  />

                  <Paginator totalItemsCount={count} pageRangeDisplayed={5} />
                </>
              )}
            </>
          )}
          {showPopup && (
            <MailForm
              visible={showPopup}
              hidePopup={() => setShowPopup(false)}
              instantMailSent={assignStartup}
              investors={investorIds}
              startupId={startupId}
              changeInvestor={changeInvestor}
              businessDescription={businessDescription}
            />
          )}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ selectedInvestor, formFields }) {
  return {
    selectedInvestor,
    formFields,
  };
}

export default connect(mapStateToProps)(Match);
